import React from 'react';

import http from 'Demora/http';

import throttle from 'lodash/throttle';

import SingleAdBox from './singleAdBox';

class adBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			a: [],
			id: React.createRef(),
			boxW: null,
			num: null,
			fetching_ads: false,
			dm: null,
			clientId: 'CJ01',
		};

		this.throttleResize = throttle(this.setNumberOfAds, 750);
	}

	componentDidMount() {
		this.setNumberOfAds();

		window.addEventListener('resize', this.throttleResize);
	}

	getData() {
		const props = this.props;

		const state = this.state;

		const uid = props.uid ? props.uid : 1;

		const l = navigator.language || navigator.browserLanguage;

		if (state.fetching_ads) {
			return;
		}

		this.setState({
			fetching_ads: true,
		});

		http
			.get(
				'/data/a1/?n=' +
					props.maxAds +
					'&l=' +
					l +
					'&id=' +
					props.boxId +
					'&cl=' +
					state.clientId
			)
			.then((data) => {
				if (!this.unmounted) {
					if (data.a) {
						this.setState(
							{
								a: data.a,
								fetching_ads: false,
								dm: data.m,
							},
							this.setNumberOfAds
						);
					}
				}
			});
	}

	componentWillUnmount() {
		this.unmounted = true;

		window.removeEventListener('resize', this.throttleResize);
	}

	setNumberOfAds = () => {
		if (this.unmounted) {
			return;
		}

		const state = this.state;

		const box = this.state.id.current.parentElement;

		const width = box.clientWidth;
		const height = box.clientHeight;

		const style = window.getComputedStyle
			? getComputedStyle(box, null)
			: box.currentStyle;

		const paddingTop = parseInt(style.paddingTop) || 0;
		const paddingBottom = parseInt(style.paddingBottom) || 0;

		const paddingLeft = parseInt(style.paddingLeft) || 0;
		const paddingRight = parseInt(style.paddingRight) || 0;

		const boxH = height - paddingTop - paddingBottom;
		const boxW = width - paddingLeft - paddingRight;

		let num = 0;

		if (boxW > 250) {
			num = parseInt(parseInt(boxW) / 236);
		} else if (boxH > 0) {
			num = parseInt(parseInt(boxH) / 113);
		}

		if (num > this.props.maxAds) {
			num = this.props.maxAds;
		}

		this.setState({
			num: num,
		});

		if (num > 0 && state.a.length == 0) {
			this.getData();
		} else if (num > 0 && state.dm) {
			http.post('/data/a1/vav/' + state.dm + '/' + num, {
				url: window.location.href,
			});

			this.setState({
				dm: null,
			});
		}

		return num;
	};

	render() {
		const state = this.state;

		const a = state.a.slice(0, state.num);

		return (
			<div id='z' ref={state.id}>
				<div className='z7'>
					{a.map((a, i) => {
						return (
							<SingleAdBox
								key={i}
								pos={i + 1}
								a={a}
								clientId={state.clientId}
								boxId={this.props.boxId}
							/>
						);
					})}
				</div>
			</div>
		);
	}
}

export default adBox;
